import * as React from 'react';
import { useState, useEffect } from 'react';

//MUI Components
import Button from '@mui/material/Button';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import Alert from '@mui/material/Alert';

//created components
import TailleCycliste from '../taillecycliste/TailleCycliste.jsx'

//selectors for redux :
import { useSelector, useDispatch } from "react-redux";
import { getPanier, getStockArticles } from "../../../../store/selectors.js"; //global state : shopping state
import { panierSlice } from "../../../../store/panierSlice.js";

//Utils :
import { calcPrix, calcPrixDegressif } from "../../../../utils/calcul_prix.js"


function ItemPanier({ article, duree }) { // component to manage the first step of shopping : choosing place and time


    let panier = useSelector(getPanier);
    let allStocks = useSelector(getStockArticles);
    //console.log("stock from panier", allStocks);
    const dispatch = useDispatch();
    const [stockRestant, setStockRestant] = useState();

    useEffect(() => {
        let dejaReserves = 0;
        let articlesReserves = allStocks.filter((art) => art.article_id === article.id_article);
        if (articlesReserves.length > 0) {
            dejaReserves = articlesReserves[0].qte;
        }
        setStockRestant(article.stock - dejaReserves - getQte());
        //console.log(getQte());
    }, [panier]);

    function getQte() {
        let currentArticle = panier.filter((ligne) => ligne.id_article === article.id_article)
        if (currentArticle.length > 0) {//"ligne" represent an article in the panier
            return (currentArticle[0].qte);
        }
        else {
            return (0);
        }
    }

    function handleChangeQte(delta) {
        let qte = getQte();
        if (qte === 0) { //article non present in panier
            if (delta === "plus") { //add new article
                dispatch(panierSlice.actions.newArticle(article));
            }
        }// end of new article

        if (qte === 1) { //jusT 1 article  present in panier
            if (delta === "plus") { //increment article
                dispatch(panierSlice.actions.incrementArticle(article));
            }
            if (delta === "moins") { //remove  article
                dispatch(panierSlice.actions.removeArticle(article));
            }
        }

        if (qte > 1) { //jusT 1 article  present in panier
            if (delta === "plus") { //increment article
                dispatch(panierSlice.actions.incrementArticle(article));
            }
            if (delta === "moins") { //decrement  article
                dispatch(panierSlice.actions.decrementArticle(article));
            }
        }

    }
    function handleDelete() {
        dispatch(panierSlice.actions.removeArticle(article));
    }

    /* 
        function getTaillesCyclistes() {
            let listCyclistes = [];
            let currentArticle = panier.filter((ligne) => ligne.id_article === article.id_article)
            if (currentArticle.length > 0) {//"ligne" represent an article in the panier
                //console.log(currentArticle[0].qte)
                for (let i = 0; i < currentArticle[0].qte; i++) {
                    //listCyclistes.push({ taille: currentArticle[0].tailles[i], prenom: currentArticle[0].prenoms[i] })
                    let cycliste = { taille: currentArticle[0].tailles[i], prenom: currentArticle[0].prenoms[i] }
                    listCyclistes.push(<TailleCycliste key={i} index={i} id_article={article.id_article} />)
                }
            }
            return listCyclistes;
        }
     */


    return (
        <div className="item-panier">
            <div className="item-panier-left">
                <div className="item-panier-left-photo">
                    <img src={article.image_url} alt="image vélo" />
                </div>
                <div className="item-panier-left-infos">
                    <div className="item-panier-left-infos-titre">
                        <h3>{article.type}</h3>
                    </div>
                    <div className="item-panier-left-infos-description">
                        <h4>{article.infos}</h4>
                        {stockRestant <= 0 ? <Alert className="item-panier-left-infos-alert" severity="error">{"Rupture de stock"}</Alert> : null}
                    </div>

                </div>
            </div>
            <div className="item-panier-right">
                <div className="item-panier-right-start">

                    <div className="item-panier-right-pu">
                        <p>P.U.</p>
                        <h3>{getQte() > 0 ? calcPrixDegressif(article.Tarif, duree) + ",00€" : null}</h3>
                        <p className="item-panier-right-pu-raw">{getQte() > 0 && calcPrixDegressif(article.Tarif, duree) < calcPrix(article.Tarif, duree) ? calcPrix(article.Tarif, duree) + ",00€" : null}</p>
                    </div>
                    <div className="item-panier-right-boutons">
                        <div className="boutons-qte-item">
                            <Button
                                /* disabled={dsbld} */
                                variant="contained"
                                /* onClick={nextStep} */
                                className="boutons-qte-item-moins" //stylise in css
                                style={{ maxWidth: '42px', maxHeight: '36px', minWidth: '42px', minHeight: '36px' }}
                                onClick={() => { handleChangeQte("moins") }}
                            > - </Button>
                            <p className="boutons-qte-item-valeur">{getQte()}</p>
                            <Button
                                disabled={stockRestant <= 0}
                                variant="contained"
                                /* onClick={nextStep} */
                                className="boutons-qte-item-plus" //stylise in css
                                style={{ maxWidth: '42px', maxHeight: '36px', minWidth: '42px', minHeight: '36px' }}
                                onClick={() => { handleChangeQte("plus") }}
                            > + </Button>

                        </div>

                    </div>
                </div>


                <div className="item-panier-right-end">
                    <div className="item-panier-right-ttc">
                        <p>Prix TTC</p>
                        <h3>{getQte() > 0 ? calcPrixDegressif(article.Tarif, duree) * getQte() + ",00€" : null}</h3>
                    </div>
                    <div className="item-panier-right-delete">
                        <DeleteForeverIcon className="item-delete-bouton" onClick={_ => handleDelete()} />
                    </div>
                </div>

            </div>


        </div>

    )
}




export default ItemPanier